import React from "react"
import { Button } from "@material-ui/core"
import { AddIcon } from "@iconsGallery"
import styled from "styled-components"

const CreateButton = styled(Button)`
  width: 100%;
  background-color: var(--lightColor);
  height: 38px;
  &:hover {
     background-color: var(--lightColor);
  }
`

function CreateAttribute(props) {
  const { onClick = () => "", disabled = false } = props || {}
  const createButtonAtrr = {
    variant: "contained",
    onClick,
    disabled,
    startIcon: <AddIcon style={{ color: disabled ? "" : "var(--primaryColor)" }} />,
  }
  return <CreateButton {...createButtonAtrr} />
}

export { CreateAttribute }
